























































































































































































import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import { Board, LayerType } from '../../../common/board';
import { Box } from '../../../common/box';
import axios from 'axios';
import _ from 'lodash';
import gql from 'graphql-tag';

import * as PAPERS_QUERY from 'src/graphql/Papers.graphql';
import * as FLUTES_QUERY from 'src/graphql/Flutes.graphql';
import * as LAYER_STUB_FRAGMENT_QUERY from 'src/graphql/LayerStubFragment.graphql';
import * as BOARD_RESULT_FRAGMENT_QUERY from 'src/graphql/BoardResultFragment.graphql';
import * as FAVORITE_BOARDS_QUERY from 'src/graphql/FavoriteBoards.graphql';
import * as BOARD_CACHED_DEFAULT_BPI_FRAGMENT_QUERY from 'src/graphql/BoardCachedDefaultBPIFragment.graphql';

@Component({
  apollo: {
    papers_for_group: {
      query: PAPERS_QUERY,
      fetchPolicy: 'cache-and-network',
    },
    flutes_for_group: {
      query: FLUTES_QUERY,
      fetchPolicy: 'cache-and-network',
    },
  }
})
export default class BoardInspector extends Vue {
  $refs: any;

  @Prop() board: Board;
  @Prop() name: string;

  papers_for_group = [];
  flutes_for_group = [];

  expanded: boolean = true;

  enableSimulation: boolean = false;

  addToFavoritesDialog = -1;
  addToFavoritesName = '';

  addingBoardToFavorites = false;
  addedBoardToFavorites = false;

  replaceFavoriteBoardDialog = false;

  favoriteBoardNameRules = [
    name => !(name == null || name.trim() == '') || 'A name is required',
    name => !this.checkIfFavoriteBoardExists(name) || 'Favorite board already exists and will be replaced',
  ];

  get project() {
    return this.$store.state.currentProject;
  }

  setPaper(layer) {
    if (layer.paper != null) {
      let foundPaper = this.papers_for_group.find( dbPaper => dbPaper.id == layer.paper.id );

      if (foundPaper) {
        layer.paper = foundPaper;
      } else {
        // Make the paper writeable.
        layer.paper = JSON.parse(JSON.stringify(layer.paper));

        if (layer.paper.deleted) {
          layer.paper.placeholder = `${layer.paper.CEPI_name} (deleted)`;
        } else if (layer.paper.newest) {
          layer.paper.placeholder = `${layer.paper.CEPI_name} (outdated)`;
        } else {
          layer.paper.placeholder = `${layer.paper.CEPI_name} (access denied)`;
        }
      }
    }
  }

  setFlute(layer) {
    if (layer.flute != null) {
      let foundFlute = this.flutes_for_group.find( dbFlute => dbFlute.id == layer.flute.id );

      if (foundFlute) {
        layer.flute = foundFlute;
      } else {
        // Make the flute writeable.
        layer.flute = JSON.parse(JSON.stringify(layer.flute));

        if (layer.flute.deleted) {
          layer.flute.placeholder = `${layer.flute.name} (deleted)`;
        } else if (layer.flute.newest) {
          layer.flute.placeholder = `${layer.flute.name} (outdated)`;
        } else {
          layer.flute.placeholder = `${layer.flute.name} (access denied)`;
        }
      }
    }
  }

  @Watch('project')
  onProjectChanged() {
    for (let layer of this.board.layers) {
      this.setPaper(layer);

      if (layer.type === LayerType[LayerType.FLUTING])
        this.setFlute(layer);
    }

    this.board.updateEnableSimulation();
  }

  @Watch('papers_for_group')
  onPapersChanged() {
    for (let layer of this.board.layers)
      this.setPaper(layer);

    this.board.updateEnableSimulation();
  }

  @Watch('flutes_for_group')
  onFlutesChanged() {
    for (let layer of this.board.layers)
      if (layer.type === LayerType[LayerType.FLUTING])
        this.setFlute(layer);

    this.board.updateEnableSimulation();
  }



  layerIsPaper(layer) {
    return layer.type === LayerType[LayerType.PAPER];
  }

  placeholder(layerItem) {
    if (layerItem && layerItem.placeholder)
      return layerItem.placeholder;

    return '';
  }

  appendIcon(layerItem) {
    if (layerItem && layerItem.newest)
      return 'update';

    return '';
  }

  appendIconCallbackPaper(layer) {
    if (!layer.paper || !layer.paper.newest)
      return;

    this.updateLayer(layer, layer.paper.newest, null);
  }

  appendIconCallbackFlute(layer) {
    if (!layer.flute || !layer.flute.newest)
      return;

    this.updateLayer(layer, null, layer.flute.newest);
  }

  onPaperChange(layer, paper: any) {
    if (paper && paper.id) {
      this.updateLayer(layer, paper, null);
    }
  }

  onFluteChange(layer, flute: any) {
    if (flute && flute.id) {
      this.updateLayer(layer, null, flute);
    }
  }

  openAddToFavoritesDialog(board) {
    this.addToFavoritesDialog = board.index;

    setTimeout(() => {
      const input = this.$refs['addToFavoritesNameRef' + board.index];
      if (input) {
        input.focus();
        input.$el.querySelector('input').select()
      }
    }, 50);
  }

  closeAddToFavoritesDialog() {
    this.addToFavoritesDialog = -1;
  }

  checkIfFavoriteBoardExists(name) {
    // While a favorite board is replaced, it is still found.
    return this.$store.getters.hasFavoriteBoard(name) || this.replaceFavoriteBoardDialog;
  }

  closeReplaceFavoriteBoardDialog() {
    this.replaceFavoriteBoardDialog = false;
  }

  updateLayer(layer, paper, flute) {
    this.$apollo.mutate({
      mutation: gql`mutation ($projectId: Int!, $boardId: Int!, $layerId: Int!, $paperId: Int, $fluteId: Int) {
          updateLayer(projectId: $projectId, boardId: $boardId, layerId: $layerId, paperId: $paperId, fluteId: $fluteId) {
            ...LayerStub
          }
        }
        ${LAYER_STUB_FRAGMENT_QUERY}
      `,
      variables: {
        projectId: this.project.id,
        boardId: this.board.id,
        layerId: layer.id,
        paperId: paper ? paper.id : null,
        fluteId: flute ? flute.id : null,
      },
      update: (store, {data: { updateLayer }}) => {
        let newLayer = JSON.parse(JSON.stringify(layer));

        if (updateLayer.paper != null)
          newLayer.paper = updateLayer.paper;

        if (updateLayer.flute != null)
          newLayer.flute = updateLayer.flute;

        store.writeFragment({
          id: `Layer:${layer.id}`,
          fragment: LAYER_STUB_FRAGMENT_QUERY,
          data: newLayer
        });

        store.writeFragment({
          id: `Board:${this.board.id}`,
          fragment: BOARD_RESULT_FRAGMENT_QUERY,
          data: {
            __typename: 'Board',
            board_result: null
          }
        });

        store.writeFragment({
          id: `Board:${this.board.id}`,
          fragment: BOARD_CACHED_DEFAULT_BPI_FRAGMENT_QUERY,
          data: {
            __typename: 'Board',
            cached_default_bpi: null,
          }
        });
      },
      optimisticResponse: {
        __typename: 'Mutation',
        updateLayer: {
          __typename: 'Layer',
          id: -1,
          type: layer.type,
          paper,
          flute,
        },
      },
    });
  }

  async addBoardToFavorites(board) {
    if (this.addToFavoritesName == null) {
      return;
    }

    this.addingBoardToFavorites = true;

    const res = await this.$apollo.mutate({
      mutation: gql`mutation ($projectId: Int!, $boardId: Int! $name: String!) {
          createFavoriteBoard(projectId: $projectId, boardId: $boardId, name: $name) {
            id
            name
            created_at
            used_at
            layers {
              ...LayerStub
            }
          }
        }
        ${LAYER_STUB_FRAGMENT_QUERY}
      `,
      variables: {
        projectId: this.project.id,
        boardId: board.id,
        name: this.addToFavoritesName.trim(),
      },
      refetchQueries: [{ query: FAVORITE_BOARDS_QUERY, variables: ( { group: null } ) }],
    });

    this.addToFavoritesDialog = -1;
    this.addToFavoritesName = '';
    this.addingBoardToFavorites = false;
    this.addedBoardToFavorites = true;

    setTimeout(() => {
      this.addedBoardToFavorites = false;
    }, 4000);
  }

  async replaceBoardInFavorites(board) {
    if (this.addToFavoritesName == null) {
      return;
    }

    const existingFavoriteBoard = this.$store.state.favorite_board_names.find( board => board.name.trim().toLowerCase() === this.addToFavoritesName.trim().toLowerCase() );
    if (existingFavoriteBoard) {
      this.$store.commit('deleteFavoriteBoard', existingFavoriteBoard);
    }

    await this.addBoardToFavorites(board);

    this.replaceFavoriteBoardDialog = false;
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/BoardInspector.vue